import { trpc, trpcVanilla } from "@client/trpc";
import type { QueryClient } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import {
  recommenderVideoMediaInput,
  workspaceRecommenderClipsInputForPath,
} from "@lib/funderWorkspaceRoutes";
import { prefetchWorkspaceClips } from "./prefetchWorkspaceClips";

export function prefetchWorkspaceRecommenderClips(
  queryClient: QueryClient,
  roundId: string,
  pathname: string,
  targetExcerptVideoId: string | null = null,
): void {
  const input = workspaceRecommenderClipsInputForPath(roundId, pathname);

  if (input == null) {
    return;
  }

  void prefetchWorkspaceClips(queryClient, {
    roundId,
    scopeId: input.recommenderId,
    initialMediaInput: recommenderVideoMediaInput(roundId, input.recommenderId),
    targetExcerptVideoId,
    clipsQuery: {
      queryKey: getQueryKey(trpc.getRecommenderTranscriptClips, input, "query"),
      queryFn: () => trpcVanilla.getRecommenderTranscriptClips.query(input),
    },
  });
}
